// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBalloon = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M19 8.5c0 4.142-3.134 7.5-7 7.5s-7-3.358-7-7.5c0-3.398 2.109-6.267 5-7.19a6.57 6.57 0 014 0c2.892.923 5 3.792 5 7.19m-2 0c0 3.17-2.366 5.5-5 5.5s-5-2.33-5-5.5c0-2.58 1.595-4.642 3.608-5.284a4.57 4.57 0 012.784 0C15.405 3.858 17 5.92 17 8.5"
    />,
    <path d="M9.385 15.46L9 17h2c0 1.049.323 1.89.837 2.55.5.64 1.142 1.057 1.716 1.344.425.213.783.467 1.034.788.236.302.413.71.413 1.318h2c0-1.049-.323-1.89-.837-2.55-.5-.64-1.142-1.057-1.716-1.344-.425-.213-.783-.467-1.034-.788-.236-.302-.413-.71-.413-1.318h2l-.385-1.54c-.808.348-1.69.54-2.615.54a6.6 6.6 0 01-2.615-.54" />
  );
export default SvgIconBalloon;
